// src/main.ts
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { useAuthStore } from './stores/auth'
import { usePermissionGuardStore } from './stores/permissionGuard'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)

const auth = useAuthStore(pinia)
auth.loadFromStorage()

const permissions = usePermissionGuardStore(pinia)
permissions.syncFromAuth()

app.use(router)

app.mount('#app')
